import SelectionModes from 'utils/SelectionModes';
import {
  buildApiParams
} from 'utils';

const selectQuery = state => state.search.searchQuery;

export const selectedBikeTypeIds = state => {
  const bikeTypes = state.app.bikeTypes.items;

  const {
    mode,
    ids
  } = selectQuery(state).bikeTypes;

  return SelectionModes(mode)(ids, bikeTypes);
};


export const selectBookingPeriod = state => {
  const {
    beginDateTime,
    endDateTime
  } = selectQuery(state);

  return {
    beginDateTime, endDateTime
  };
};

export const selectSearchQuery = state => {
  const bikeTypes = selectedBikeTypeIds(state);

  const {
    params,
    beginDateTime,
    endDateTime
  } = selectQuery(state);

  return buildApiParams({
    beginDateTime,
    endDateTime,
    bikeTypes,
    ...params
  });
};



// WEBPACK FOOTER //
// ./src/selectors/searchQuery.js